export enum LearningContentPageFilters {
  DRAFT = 'draft',
  RECENT = 'recent',
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}
export interface LearningContentProps {
  filter: LearningContentPageFilters;
}

export enum ContentCardMenuActions {
  View = 'VIEW',
  Edit = 'EDIT',
  Assign = 'ASSIGN',
  Duplicate = 'DUPLICATE',
  Publish = 'PUBLISH',
  ExportQuiz = 'EXPORT_QUIZ',
  Delete = 'DELETE',
  Archive = 'ARCHIVE',
  UnArchive = 'UNARCHIVE',
  RevertChanges = 'REVERT_CHANGES',
}

export enum ActionDialog {
  Delete = 'DELETE',
  Archive = 'ARCHIVE',
  Share = 'SHARE',
  ExportQuiz = 'EXPORT_QUIZ',
  RevertChanges = 'REVERT_CHANGES',
}

export enum DialogActions {
  Delete = 'DELETE',
  Archive = 'ARCHIVE',
  Close = 'CLOSE',
}
